export enum PageType {
  Unknown,
  LandingOrHub,
  Template,
  Color,
}

export const COLOR_PAGE_PATH = 'colors/color-meanings/';

export const TEMPLATES_PAGE_PATH = 'templates';
